module.exports = __webpack_public_path__ + "img/table_erpprojectcost.6540f472.png";